'use client'

import { supabase } from "@/lib/supabase/browser-client"
import { env } from "next-runtime-env"
import { redirect } from "next/navigation"
import { logError } from '@/utils/errorLogging'
import { createIsomorphicLogger } from '@/utils/logger/isomorphicLogger'
import { getPublicURL } from "@/lib/utils"

const logger = createIsomorphicLogger('sso.button')

type Props = {
  className?: string
}

export function SSOLoginButton({ className }: Props) {
  const handleSSOLogin = async () => {
		const samlDomain = env("NEXT_PUBLIC_SAML_DOMAIN")
		if (!samlDomain) {
			const errorMsg = "SSO domain is not configured"
			logError(logger, new Error(errorMsg))
			return redirect(`/login?message=${errorMsg}`)
		}

		const redirectUrl = getPublicURL('/auth/callback')
		logger.info(`SSO login initiated, redirectTo: ${redirectUrl}`)
		const {  data, error } = await supabase.auth.signInWithSSO({
			domain: samlDomain,
			options: {
				redirectTo: redirectUrl
			}
		})

		if (error) {
			logError(logger, error)
			return redirect(`/login?message=${error.message}`)
		}

		if (data?.url) { // redirect the user to the identity provider's authentication flow
			window.location.href = data.url
		}
  }

  return (
    <button
      type="button"
      onClick={handleSSOLogin}
      className={className}
    >
      SSO
    </button>
  )
}